import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatasourcesDisplayGridRowDataFragment, LensUpstreamDatasourcesQuery, LensUpstreamDatasourcesQueryVariables, PublishedDatasourceSortOrder , LensUpstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { DatasourcesDisplayGrid, DatasourcesDisplayGridRowData, getRowDataForDatasource } from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = LensUpstreamDatasourcesQueryVariables;
type QueryResults = LensUpstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0]?.upstreamDatasourcesConnection;
}

export type LensUpstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & Readonly<{
    vizportalUrlId: string;
    rowCount: number | null;
  }>;

export const LensUpstreamDatasourcesQueryGrid: React.FC<LensUpstreamDatasourcesQueryGridProps> = props => {
  const emptyGridMessage = Messages.EmptyUpstreamDatasourcesLineageGridMessage();
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamDatasourcesDocument}
      partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) =>
        <DatasourcesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
}
